export const SHOTLIST_MAX_CHARACTER_VARIANTS = 5
